import { MasterDataProvider } from "./context/MasterDataContext";
import Home from "./screen/Home";
import Agent from "./screen/Agent-login";
import Otp_verification from "./screen/Otp_verification";
import { Routes, Route, useNavigate } from "react-router-dom";
import Employee_sign from "./screen/Employee_sign";
import Business_set_up from "./screen/Business_set_up";
import Business_set_upFromPage from "./Pages/Business_set_up";
import DashBoard from "./screen/DashBoard";
import ProfileDisplay from "./screen/ProfileDisplay";
import RedirectHandler from "./screen/RedirectHandler";
import SettingsPage from "./screen/SettingsPage";
import AccountConfiguration from "./screen/AccountConfiguration";
import OnboardingPage from "./screen/OnboardingPage";
import BrowseAgents from "./screen/BrowseAgents";
import SearchProfiles from "./screen/SearchProfiles";
import ProfileDisplayForClient from "./screen/ProfileDisplayForClient";
import CreateNewClient from "./screen/CreateNewClient";
import Clientlogin from "./screen/ClientLogin";
import DisplayAgentsForClient from "./screen/DisplayAgentsForClient";
import CreateNewClientForProfile from "./screen/CreateNewClientForProfile";
import EditClientProfile from "./screen/EditClientProfile";
import Client_set_up from "./screen/Client_set_up";
import Business from "./screen/Business";
import EditBusiness_set_up from "./screen/EditBusiness_set_up";
import EditClient_set_up from "./screen/EditClient_set_up";
import { useEffect } from "react";
import packageJson from "../package.json";
import { useMasterData } from "./context/MasterDataContext";
import logo from "../src/assests/images/menubar_logo.png"; // D:\Zenvaedev\Vittal Dev\wedluckWebClient\src\assests\images\menubar_logo.png
import Login from "./screen/Login";
import ProfileLoginPage from "./screen/ProfileLoginPage";
import ClientProfileSelection from "./components/ClientSetup/ClientProfileSelection";
import AgentDetails from "./components/AgentDetails";
import ReviewAgent from "./components/ReviewAgent";
import AllAgentReviews from "./components/AllAgentReviews";
import SignUp from "./screen/SignUp";
import TermsAndConditions from "./screen/TermsAndConditions";
import BusinessNetworkComingSoon from "./screen/BusinessNetworkComingSoon";

function App() {
  const { masterLoading } = useMasterData();

  useEffect(() => {
    const currentVersion = packageJson.version;
    const savedVersion = localStorage.getItem("app_version");

    if (savedVersion !== currentVersion) {
      localStorage.clear(); // 🔥 Clears all old data
      localStorage.setItem("app_version", currentVersion);
    }
  }, []);

  if (masterLoading) {
    return (
      <div className="loading-screen">
        <img src={logo} alt="Logo" className="logo-3d" />
      </div>
    );
  }
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<RedirectHandler />} />
        <Route path="/home" element={<Home />} />
        <Route path="/business" element={<Business />} />
        <Route path="/login" element={<AccountConfiguration />} />
        <Route path="/loginpage" element={<Login />} />
        <Route path="/ClientloginType" element={<Clientlogin />} />
        <Route path="/agent" element={<Agent />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/otp_verify" element={<Otp_verification />} />
        <Route path="/employee_sign_in" element={<Employee_sign />} />
        <Route path="/business_setup" element={<Business_set_upFromPage />} />
        <Route path="/editBusiness_set_up" element={<EditBusiness_set_up />} />
        <Route path="/client_setup" element={<Client_set_up />} />
        <Route path="/edit-client" element={<EditClient_set_up />} />
        <Route path="/dashboard" element={<DashBoard />} />
        <Route path="/profile" element={<ProfileDisplay />} />
        <Route path="/profileforclient" element={<ProfileDisplayForClient />} />
        <Route path="/clientlogin" element={<OnboardingPage />} />
        <Route path="/profilelogin" element={<ProfileLoginPage />} />
        <Route path="/browseagents" element={<BrowseAgents />} />
        <Route path="/search-profiles" element={<SearchProfiles />} />
        <Route path="/newclient" element={<CreateNewClient />} />
        <Route path="/EditClientProfile" element={<EditClientProfile />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route
          path="/business-network-coming-soon"
          element={<BusinessNetworkComingSoon />}
        />
        <Route
          path="/client-profile-selection"
          element={<ClientProfileSelection />}
        />
        <Route
          path="/CreateNewClientForProfile"
          element={<CreateNewClientForProfile />}
        />
        <Route
          path="/DisplayAgentsForClient"
          element={<DisplayAgentsForClient />}
        />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/agent-details" element={<AgentDetails />} />
        <Route path="/review-agent" element={<ReviewAgent />} />
        <Route path="/all-agent-reviews" element={<AllAgentReviews />} />
      </Routes>
    </div>
  );
}

export default App;
